






import Vue from 'vue'
import Component from 'vue-class-component'
import Status from './Status.vue'
import { EStatusType } from '@/components/statuses/EStatusType'
import { CHAIN_STATUSES_LABEL_MAP } from '@/constants'
import { EChainStatus } from '@zunta/configurations'

@Component({
  components: { Status },
  props: {
    status: {
      status: String,
      required: true
    }
  }
})
export default class StatusChain extends Vue {
  get type (): EStatusType {
    if (!this.$props.status) {
      return EStatusType.default
    }

    switch (this.$props.status) {
      case EChainStatus.ACTIVE:
        return EStatusType.success
      case EChainStatus.NOT_ACTIVE:
        return EStatusType.error
      default:
        return EStatusType.default
    }
  }

  get text (): string {
    if (!this.$props.status) {
      return ''
    }
    return CHAIN_STATUSES_LABEL_MAP[this.$props.status]
  }
}
